import {Route, Routes} from 'react-router-dom';

import {getSubRoute} from 'config/navigation';
import {useRedirectToLoginOnBackAfterConfirmation} from 'features/CreateAccount/hooks/navigationState';
import Loadable, {Suspense} from 'utils/Loadable';

const AccountCreated = Loadable({loader: () => import('./AccountCreated')});
const AccountVerification = Loadable({loader: () => import('./AccountVerification')});
const ChoosePassword = Loadable({loader: () => import('./ChoosePassword')});
const CreateAccountConfirmation = Loadable({loader: () => import('./CreateAccountConfirmation')});
const CreateAccountQuestions = Loadable({loader: () => import('./CreateAccountQuestions')});
const CreateLoginID = Loadable({loader: () => import('./CreateLoginID')});

const CreateAccount = () => {
  useRedirectToLoginOnBackAfterConfirmation();
  return (
    <main id="mainContent">
      <Suspense>
        <Routes>
          <Route path={getSubRoute('/create-account/loginID')} element={<CreateLoginID />} />
          <Route path={getSubRoute('/create-account/confirmation')} element={<CreateAccountConfirmation />} />
          <Route path={getSubRoute('/create-account/accountVerification')} element={<AccountVerification />} />
          <Route path={getSubRoute('/create-account/authorization/:token', {}, 2)} element={<ChoosePassword />} />
          <Route path={getSubRoute('/create-account/success')} element={<AccountCreated />} />
          <Route index path="*" element={<CreateAccountQuestions />} />
        </Routes>
      </Suspense>
    </main>
  );
};

export default CreateAccount;
